<div class="mb-3 flex items-center gap-4" [formGroup]="formSearch">
  <mat-form-field
    class="input-tg search-tg mt-message-input w-5/5"
    appearance="outline"
  >
    <mat-label>Pesquisa</mat-label>
    <input matInput formControlName="search" (keydown.enter)="sendSearch()" />
  </mat-form-field>
  <div>
    <button
      class="btn-icon"
      (click)="sendSearch()"
      [disabled]="!checkForm()"
      [ngClass]="checkForm() ? '' : 'disabled'"
      [matTooltip]="checkSearch() ? 'Pesquisa' : 'Limpar Pesquisar'"
    >
      @if (checkSearch()) {
        <mat-icon>search</mat-icon>
      } @else {
        <mat-icon>replay</mat-icon>
      }
    </button>
  </div>
</div>
